import React, { Component } from 'react';

import {
  createStore,
  applyMiddleware
} from 'redux'

import {
  Provider
} from 'react-redux'

import thunk from 'redux-thunk'

import reducers from './reducers'
import Routes from './routes'

const store = createStore(
  reducers,
  applyMiddleware(thunk)
)

class App extends Component {
  render() {
    return (
      <Provider store={store}>
        <Routes />
      </Provider>
    );
  }
}

export default App;




// WEBPACK FOOTER //
// ./src/App.js